import { ETripTaskType } from 'types/trips';

export const TRIP_TASK_TYPE_MAP: Record<ETripTaskType, string> = {
  [ETripTaskType.loading]: 'Load',
  [ETripTaskType.loading_wh]: 'WH load',
  [ETripTaskType.unloading]: 'Unload',
  [ETripTaskType.unloading_wh]: 'WH unload',
  [ETripTaskType.customs]: 'Customs',
  [ETripTaskType.reloading_from]: 'Reload out',
  [ETripTaskType.reloading_to]: 'Reload in',
  [ETripTaskType.trailer_swap]: 'Swap',
  [ETripTaskType.return_asset]: 'Return asset',
};

export const TYPE_TAG_COLOR_MAP: Record<ETripTaskType, string> = {
  [ETripTaskType.loading]: 'blue',
  [ETripTaskType.loading_wh]: 'blue',
  [ETripTaskType.reloading_to]: 'blue',
  [ETripTaskType.unloading]: 'cyan',
  [ETripTaskType.unloading_wh]: 'cyan',
  [ETripTaskType.reloading_from]: 'cyan',
  [ETripTaskType.customs]: 'gray',
  [ETripTaskType.trailer_swap]: 'gray',
  [ETripTaskType.return_asset]: 'purple',
};
